import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeprecatedConfirmationDialogComponent, DeprecatedModalFormComponent } from '@app/components';
import { AssetAssignment } from '@app/models/company/asset-assignment.model';
import { Asset } from '@app/models/company/asset.model';
import { IndexView } from '@app/modules/common/views';
import { AssetsIndexTable, CompanyMenuService } from '@app/modules/company/services';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { NotifyService } from '@app/services';

@Component({
    templateUrl: './assets-index.template.html',
    styleUrls: ['./assets-index.style.scss'],
})
export class AssetsIndexView extends IndexView {
    @ViewChild('confirmDeleteAssetDialog', { static: true })
    confirmDeleteAssetDialog: DeprecatedConfirmationDialogComponent;
    @ViewChild('assignAssetModal', { static: true }) assignAssetModal: DeprecatedModalFormComponent;
    @ViewChild('reassignAssetModal', { static: true }) reassignAssetModal: DeprecatedModalFormComponent;

    isLoading = true;

    currentAsset: Asset = new Asset();
    assetReassignment: AssetAssignment;

    constructor(
        public table: AssetsIndexTable,
        private router: Router,
        private route: ActivatedRoute,
        private notify: NotifyService,
        public companyMenuService: CompanyMenuService
    ) {
        super();
        this.table.onLoading.subscribe((isLoading) => (this.isLoading = isLoading));
        this.table.reload();
    }

    async onTableMenuEvent(event: MenuColumnEvent): Promise<void> {
        const eventType = event.menuItem.event;
        this.currentAsset = event.data as Asset;

        switch (eventType) {
            case 'assign':
                if (!this.currentAsset.assignment?.employee) {
                    this.resetAssetAssignment();
                    this.currentAsset.assignment = new AssetAssignment();
                    this.assignAssetModal.show();
                    break;
                }
                this.assetReassignment = new AssetAssignment();
                this.reassignAssetModal.show();
                break;
            case 'edit':
                this.router.navigate([String(this.currentAsset.id), 'edit'], { relativeTo: this.route });
                break;
            case 'delete':
                this.onDelete(this.currentAsset);
                break;
        }
    }

    onAssignAsset(assetAssignment: AssetAssignment): void {
        this.isLoading = true;
        assetAssignment.assetId = this.currentAsset.id;

        assetAssignment
            .param('asset', assetAssignment.assetId)
            .save()
            .then(() => {
                this.table.reload();
                this.isLoading = false;
            })
            .catch((err) => {
                this.notify.error(err.message || 'Asset could not be assigned.');
            });
    }

    onDelete(asset: Asset): void {
        this.confirmDeleteAssetDialog.show().then((confirm) => {
            if (!confirm) {
                return;
            }

            this.isLoading = true;
            asset
                .delete()
                .then(() => {
                    this.table.reload();
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.notify.error(err.message || 'Asset could not be deleted');
                });
        });
    }

    onCancel(): void {
        this.resetAssetAssignment();
    }

    resetAssetAssignment(): void {
        if (this.assetReassignment) {
            this.assetReassignment = null;
            return;
        }
        this.currentAsset.assignment = null;
    }
}
